import { useState } from "react";
import axiosHttp from "../handlers/AxiosHandler";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import MaskedInput from "react-text-mask";
import Building from "./CompanyEstablished.png";
import { showToaster } from "../../toster";

const Login = () => {
    const [mobileNo, setMobileNo] = useState("");
    const [otp, setOTP] = useState("");
    const [isOTPSent, setIsOTPSent] = useState(false);
    const [IsBothAccount, setIsBothAccount] = useState(false);

    const MobilEdit = () => {
        setIsOTPSent(false)
    }
    const navigate = useNavigate();
    const GoMobile = async (mobileNo) => {
        try {
            if (mobileNo.length !== 10) {
                showToaster({
                    message: "Please enter a valid 10-digit mobile number",
                    type: "error",
                });
                return;
            }else if (/^(\d)\1{5}/.test(mobileNo.substring(0, 6))) {
                showToaster({
                    message: "First 6 digits cannot be all the same",
                    type: "error",
                });
                return;
            } 
            const resExist = await axiosHttp.post("/Account/CheckUserCustomerExist", {
                UserID: mobileNo,
                
            });
            console.log(resExist, "resExist")
            if (
                resExist.data.statusCode === 200 &&
                resExist.data.result.isCustomerExists
            ) {

                if (
                    resExist.data.result.isUserExists &&
                    resExist.data.result.isCustomerExists
                ) {
                    setIsBothAccount("Exist");
                }
                const res = await axiosHttp.post("/Account/SendLoginOTP", {
                    userID: mobileNo,
                    userType: "c", // c=customer, p=POS
                });

                if (res.status === 200 && res.data.statusCode === 200) {
                    setIsOTPSent(true);
                    showToaster({
                        message: "OTP sent",
                        type: "success",
                    });
                } else {
                    showToaster({
                        message: "Unable to send OTP!",
                        type: "error",
                    });
                }
            } else {
                showToaster({
                    message: "Customer does not exist!",
                    type: "error",
                });
                setIsBothAccount("NotExist");
            }
        } catch (error) {
            console.error("Error during mobile validation:", error);
            showToaster({
                message: "Something went wrong, please try again later.",
                type: "error",
            });
        }
    };

    const VerifyOTP = async (otp) => {
        if (otp.length !== 5) {
            showToaster({
                message: "Invalid OTP!",
                type: "error",
            });
            return;
        }

        try {
            const res = await axiosHttp.post("/Account/LoginCustomer", {
                userID: mobileNo,
                otp: otp,
            });
            console.log(res, "Login")
            if (res.status === 200 && res.data.statusCode === 200) {
                localStorage.setItem("smc-csp-token", res.data.result.customerToken);
                localStorage.setItem("MobileNo", mobileNo);
                localStorage.setItem(
                    "smc-csp-customer-name",
                    res.data.result.customerName
                );
                navigate("/dashboard");
            } else {
                showToaster({
                    message: "Unable to login!",
                    type: "error",
                });
            }
        } catch (error) {
            showToaster({
                message: "Please enter valid OTP!",
                type: "error",
            });
        }
    };

    return (
        <div className="logi-FX">
            <div className="login_base">
                <div className="half-circle"></div>
                <div className="Login_Circle"></div>
            </div>
            <div className="Login_dashed">
                <div className="LOG-ViEW">
                    <div className="LOginMA">
                        <img src="https://www.smcinsurance.com/myaccount/images/smclogo.png" />
                    </div>
                    <div className="LOg-logo">
                        <ul>
                            <li>
                                <div className="SUB_child">
                                    <img src="https://www.smcinsurance.com/myaccount/images/Login/Bpremium.png" />
                                </div>
                                <div className="SuB_Baner">
                                    <p>
                                        Business Premium
                                        <b>27.25 Billion +</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="SUB_child">
                                    <img src="https://www.smcinsurance.com/myaccount/images/Login/Policysold.png" />
                                </div>
                                <div className="SuB_Baner">
                                    <p>
                                        Policies Sold
                                        <b>10 Million +</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="SUB_child">
                                    <img src="https://www.smcinsurance.com/myaccount/images/Login/ClaimAssisted.png" />
                                </div>
                                <div className="SuB_Baner">
                                    <p>
                                        Claims Assisted
                                        <b>1.7 Million +</b>
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div className="SUB_child">
                                    <img src={Building} alt="" />
                                </div>
                                <div className="SuB_Baner">
                                    <p>
                                        Established for
                                        <b>18 Years +</b>
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <img
                            src="https://www.smcinsurance.com/myaccount/images/Login/login.png"
                            className="LOGLP"
                        />
                    </div>
                </div>
                <div className="logBand">
                    <div className="LOginWA">
                        <img src="https://www.smcinsurance.com/myaccount/images/smclogo.png" />
                    </div>
                    <div className="login-Baner">
                        <small>Manage policies | Sync policies | Renewal alerts</small>
                    </div>
                    <div className="LOG-field">
                        <p>
                            <span>Login</span> to your account
                        </p>
                        <div>
                            <div className="login-FILD">
                                <div className="input-wrap">
                                    <MaskedInput
                                        mask={[
                                            /[6-9]/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        guide={false}
                                        showMask={false}
                                        className="textdemo"
                                        disabled={isOTPSent}
                                        value={mobileNo}
                                        placeholder=" "
                                        onChange={(e) => {
                                            setMobileNo(e.target.value);
                                            if (e.target.value.length == 10) GoMobile(e.target.value);
                                        }}
                                    />
                                    <label className="demo-label" htmlFor="ForUp1">
                                        Mobile Number
                                    </label>
                                    {isOTPSent &&
                                        <span onClick={() => MobilEdit()}><i class="fas fa-pencil-alt"></i></span>
                                    }
                                </div>
                            </div>
                            <div className="login-FILD" hidden={!isOTPSent}>
                                <div className="input-wrap">
                                    <MaskedInput
                                        mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} // OTP mask for 5 digits
                                        guide={false}
                                        showMask={false}
                                        className="textdemo"
                                        style={{ textTransform: "uppercase" }}
                                        value={otp}
                                        placeholder=" "
                                        onChange={(e) => {
                                            setOTP(e.target.value);
                                            if (e.target.value.length == 5) VerifyOTP(e.target.value);
                                        }}
                                    />
                                    <label className="demo-label" htmlFor="ForUp1">
                                        Verify OTP
                                    </label>
                                </div>
                            </div>                            
                        </div>

                        {IsBothAccount === "Exist" && (
                            <div className="BothAccount">
                                <i class="fas fa-square"></i> Seems you also have a POS account! {" "}
                                <a href="/myaccount">Click here</a> to login
                            </div>
                        )}
                        {IsBothAccount === "NotExist" && (
                            <div className="BothAccount">
                                <i class="fas fa-square"></i> Are you interested to{" "}
                                <a href="/myaccount">Become a POS</a> ?
                            </div>
                        )}
                        {IsBothAccount !== "Exist" && IsBothAccount !== "NotExist" && (
                            <div className="BothAccount">
                                <i class="fas fa-square"></i> Are you interested to{" "}
                                <a href="/myaccount">Become a POS</a> ?
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
